function Grid({ children, columns = 2, gap = "16px" }) {

  const gridTemplateColumns =
    columns === 1
      ? "1fr"
      : "repeat(auto-fit, minmax(260px, 1fr))";

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns,
        gap,
      }}
    >
      {children}
    </div>
  );
}

export default Grid;
